import { useState } from "react";
import { Link } from "react-router-dom";

const categories = ["All", "Kitchen Extensions", "Orangeries", "Flat Roofs", "Hallways & Landings"];

const installations = [
  {
    id: 1,
    src: "https://public.readdy.ai/ai/img_res/9a55605ac81c714aa955403519da877f.jpg",
    alt: "Kitchen roof lantern, Caterham",
    category: "Kitchen Extensions",
    location: "Caterham, Surrey",
    size: "2.5m × 1.5m",
    colour: "Anthracite Grey RAL 7016",
    glazing: "Double unit, solar control",
    room: "Kitchen-diner extension",
    desc: "A medium lantern in Anthracite Grey installed over a rear kitchen extension. The homeowner wanted maximum light without overheating — solar control glazing was specified.",
  },
  {
    id: 2,
    src: "https://readdy.ai/api/search-image?query=elegant%20white%20aluminium%20roof%20lantern%20orangery%20centre%20ceiling%20feature%20natural%20light%20daylight%20architectural%20beautiful%20traditional%20uk%20interior%20premium%20quality&width=800&height=560&seq=rlgal-2&orientation=landscape",
    alt: "Orangery roof lantern, Redhill",
    category: "Orangeries",
    location: "Redhill, Surrey",
    size: "3.0m × 2.0m",
    colour: "White RAL 9010",
    glazing: "Triple unit, low-E",
    room: "Orangery",
    desc: "A large white lantern forming the centrepiece of a new timber-and-brick orangery. Triple glazing was chosen for year-round thermal comfort.",
  },
  {
    id: 3,
    src: "https://readdy.ai/api/search-image?query=slim%20modern%20roof%20lantern%20flat%20roof%20extension%20exterior%20view%20rear%20garden%20uk%20home%20anthracite%20aluminium%20low%20pitch%20contemporary%20architectural%20minimal%20design&width=800&height=560&seq=rlgal-3&orientation=landscape",
    alt: "Flat roof lantern exterior, Oxted",
    category: "Flat Roofs",
    location: "Oxted, Surrey",
    size: "2.0m × 1.0m",
    colour: "Anthracite Grey RAL 7016",
    glazing: "Double unit, self-cleaning",
    room: "Single-storey flat roof extension",
    desc: "Self-cleaning glass was a priority for this property — the lantern is positioned over a flat roof with limited access, so easy maintenance was essential.",
  },
  {
    id: 4,
    src: "https://readdy.ai/api/search-image?query=upward%20view%20through%20roof%20lantern%20glass%20sky%20clouds%20blue%20aluminium%20bars%20thin%20slimline%20dramatic%20interior%20perspective%20daylight%20modern%20home%20photography&width=800&height=560&seq=rlgal-4&orientation=landscape",
    alt: "Roof lantern sky view, Coulsdon",
    category: "Kitchen Extensions",
    location: "Coulsdon, Surrey",
    size: "2.5m × 2.0m",
    colour: "Black RAL 9005",
    glazing: "Double unit, solar control",
    room: "Open-plan kitchen extension",
    desc: "The homeowners wanted a bold black frame to complement their monochrome kitchen design. The dramatic upward view of the sky is a feature the family loves.",
  },
  {
    id: 5,
    src: "https://readdy.ai/api/search-image?query=hallway%20corridor%20roof%20lantern%20small%20square%20skylight%20light%20shaft%20natural%20daylight%20interior%20dark%20narrow%20hallway%20transformed%20bright%20uk%20home&width=800&height=560&seq=rlgal-5&orientation=landscape",
    alt: "Hallway lantern, Warlingham",
    category: "Hallways & Landings",
    location: "Warlingham, Surrey",
    size: "1.0m × 1.0m",
    colour: "White RAL 9010",
    glazing: "Double unit, standard",
    room: "Central hallway",
    desc: "A compact 1m × 1m lantern transformed a previously dark and narrow hallway into the lightest part of the house. One of our most impactful small installations.",
  },
  {
    id: 6,
    src: "https://readdy.ai/api/search-image?query=large%20open%20plan%20orangery%20roof%20lantern%20interior%20living%20room%20extension%20natural%20light%20plants%20greenery%20uk%20home%20premium%20quality%20photography%20bright%20warm&width=800&height=560&seq=rlgal-6&orientation=landscape",
    alt: "Large orangery lantern, Purley",
    category: "Orangeries",
    location: "Purley, Surrey",
    size: "4.0m × 2.0m",
    colour: "Cream RAL 9001",
    glazing: "Triple unit, self-cleaning",
    room: "Full orangery",
    desc: "Our largest standard lantern size, fitted into a heritage cream orangery. Triple glazing and self-cleaning glass were chosen for this prestige project.",
  },
  {
    id: 7,
    src: "https://readdy.ai/api/search-image?query=contemporary%20flat%20roof%20extension%20rear%20uk%20home%20exterior%20view%20two%20roof%20lanterns%20aluminium%20dark%20frame%20modern%20house%20garden%20patio%20design&width=800&height=560&seq=rlgal-7&orientation=landscape",
    alt: "Twin roof lanterns, Kenley",
    category: "Flat Roofs",
    location: "Kenley, Surrey",
    size: "2× 1.5m × 1.0m",
    colour: "Anthracite Grey RAL 7016",
    glazing: "Double unit, solar control",
    room: "Dual flat roof extension",
    desc: "Twin matching lanterns installed side-by-side across a wide flat roof extension. Matching solar control glazing ensures both rooms stay comfortable in summer.",
  },
  {
    id: 8,
    src: "https://readdy.ai/api/search-image?query=landing%20stairwell%20upper%20floor%20roof%20lantern%20light%20flooding%20down%20stairs%20interior%20uk%20home%20natural%20daylight%20beautiful%20architectural%20detail%20photography&width=800&height=560&seq=rlgal-8&orientation=landscape",
    alt: "Landing lantern, Banstead",
    category: "Hallways & Landings",
    location: "Banstead, Surrey",
    size: "1.2m × 0.8m",
    colour: "White RAL 9010",
    glazing: "Double unit, standard",
    room: "Upper landing / stairwell",
    desc: "Installed above a stairwell, this compact lantern pours light down through two floors of the home. A remarkably affordable way to brighten the entire central core.",
  },
  {
    id: 9,
    src: "https://readdy.ai/api/search-image?query=kitchen%20extension%20roof%20lantern%20bifold%20doors%20garden%20view%20uk%20home%20interior%20bright%20modern%20minimal%20open%20plan%20living%20dining%20design%20photography%20quality&width=800&height=560&seq=rlgal-9&orientation=landscape",
    alt: "Kitchen + bi-fold combo, Epsom",
    category: "Kitchen Extensions",
    location: "Epsom, Surrey",
    size: "3.0m × 1.5m",
    colour: "Anthracite Grey RAL 7016",
    glazing: "Double unit, solar control",
    room: "Rear kitchen-diner with bi-fold doors",
    desc: "Paired with our aluminium bi-fold doors, this large lantern creates an exceptionally bright and seamless connection between indoors and garden.",
  },
  {
    id: 10,
    src: "https://readdy.ai/api/search-image?query=garden%20room%20orangery%20sunroom%20roof%20lantern%20interior%20cream%20white%20aluminium%20winter%20garden%20plants%20natural%20light%20peaceful%20uk%20home%20photography&width=800&height=560&seq=rlgal-10&orientation=landscape",
    alt: "Garden room lantern, Reigate",
    category: "Orangeries",
    location: "Reigate, Surrey",
    size: "2.0m × 1.5m",
    colour: "Sage Green RAL 6021",
    glazing: "Triple unit, low-E",
    room: "Garden room / sun room",
    desc: "A sage green lantern specified to complement the homeowner's heritage-style garden room. Triple glazing makes this room usable comfortably year-round.",
  },
  {
    id: 11,
    src: "https://readdy.ai/api/search-image?query=flat%20roof%20extension%20interior%20view%20living%20space%20roof%20lantern%20natural%20light%20minimalist%20modern%20design%20uk%20home%20furniture%20comfortable%20bright%20clean%20photography&width=800&height=560&seq=rlgal-11&orientation=landscape",
    alt: "Living room flat roof lantern, Croydon",
    category: "Flat Roofs",
    location: "Croydon, South London",
    size: "2.5m × 1.5m",
    colour: "White RAL 9010",
    glazing: "Double unit, self-cleaning",
    room: "Living room flat roof extension",
    desc: "A white-framed lantern fitted to a living room extension across the boundary of Surrey and South London. One of our most requested finishes, white stays timeless.",
  },
  {
    id: 12,
    src: "https://readdy.ai/api/search-image?query=bespoke%20large%20roof%20lantern%20dining%20room%20kitchen%20open%20plan%20uk%20home%20wide%20frame%20modern%20interior%20natural%20light%20beautiful%20photographed%20high%20quality&width=800&height=560&seq=rlgal-12&orientation=landscape",
    alt: "Bespoke XL lantern, Oxted",
    category: "Kitchen Extensions",
    location: "Oxted, Surrey",
    size: "4.2m × 2.2m (bespoke)",
    colour: "Black RAL 9005",
    glazing: "Triple unit, solar control",
    room: "Large kitchen-diner extension",
    desc: "Our biggest installed lantern to date — a bespoke oversize unit in gloss black with triple glazing. Built and installed by our team over two days including the structural surround.",
  },
];

export default function InstallationGallery() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const filtered = activeCategory === "All"
    ? installations
    : installations.filter(i => i.category === activeCategory);

  const openLightbox = (idx: number) => setLightboxIndex(idx);
  const closeLightbox = () => setLightboxIndex(null);
  const prevPhoto = () => setLightboxIndex(prev => prev !== null ? (prev - 1 + filtered.length) % filtered.length : null);
  const nextPhoto = () => setLightboxIndex(prev => prev !== null ? (prev + 1) % filtered.length : null);

  const current = lightboxIndex !== null ? filtered[lightboxIndex] : null;

  return (
    <section id="gallery" className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="text-amber-600 text-xs font-bold tracking-widest uppercase" style={{ fontFamily: "'Raleway', sans-serif" }}>Project Gallery</span>
          <h2 className="text-4xl font-bold text-zinc-900 mt-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Roof Lantern Installations Across Surrey
          </h2>
          <p className="text-zinc-500 text-sm mt-3 max-w-xl mx-auto" style={{ fontFamily: "'Raleway', sans-serif" }}>
            Real installations completed by our team across Caterham, Redhill, Epsom, Croydon and the wider Surrey area. Click any photo for full project details.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-2 justify-center mb-8">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-xs font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === cat
                  ? "bg-amber-600 text-white"
                  : "bg-white border border-stone-200 text-zinc-600 hover:border-amber-400 hover:text-amber-600"
              }`}
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              {cat}
              {cat !== "All" && (
                <span className="ml-1.5 opacity-60">
                  ({installations.filter(i => i.category === cat).length})
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Photo count */}
        <p className="text-center text-xs text-zinc-400 mb-6" style={{ fontFamily: "'Raleway', sans-serif" }}>
          Showing {filtered.length} installation{filtered.length !== 1 ? "s" : ""}
        </p>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((item, idx) => (
            <div
              key={item.id}
              onClick={() => openLightbox(idx)}
              className="group relative overflow-hidden rounded-lg cursor-pointer bg-zinc-100"
            >
              <div className="w-full h-56 md:h-64 overflow-hidden">
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-white text-sm font-bold" style={{ fontFamily: "'Raleway', sans-serif" }}>{item.location}</p>
                  <div className="flex items-center gap-3 mt-1">
                    <span className="text-amber-400 text-xs" style={{ fontFamily: "'Raleway', sans-serif" }}>{item.size}</span>
                    <span className="text-stone-300 text-xs" style={{ fontFamily: "'Raleway', sans-serif" }}>· {item.colour}</span>
                  </div>
                </div>
                <div className="absolute top-3 right-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full backdrop-blur-sm">
                    <i className="ri-zoom-in-line text-white text-sm"></i>
                  </div>
                </div>
              </div>
              {/* Category badge */}
              <div className="absolute top-3 left-3">
                <span className="bg-amber-600/90 backdrop-blur-sm text-white text-xs font-semibold px-2.5 py-1 rounded-full" style={{ fontFamily: "'Raleway', sans-serif" }}>
                  {item.category}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link to="/gallery" className="inline-flex items-center gap-2 text-amber-600 font-semibold hover:gap-3 transition-all cursor-pointer" style={{ fontFamily: "'Raleway', sans-serif" }}>
            View Full Project Gallery
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></div>
          </Link>
        </div>
      </div>

      {/* Lightbox Modal */}
      {current && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
          onClick={closeLightbox}
        >
          <div
            className="relative w-full max-w-5xl bg-white rounded-xl overflow-hidden grid lg:grid-cols-2 max-h-[90vh]"
            onClick={e => e.stopPropagation()}
          >
            {/* Image side */}
            <div className="relative w-full h-64 lg:h-auto min-h-[280px]">
              <img
                src={current.src}
                alt={current.alt}
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute top-4 left-4 bg-amber-600/90 text-white text-xs font-semibold px-3 py-1 rounded-full" style={{ fontFamily: "'Raleway', sans-serif" }}>
                {current.category}
              </span>
            </div>
            {/* Detail side */}
            <div className="p-7 flex flex-col overflow-y-auto">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-2xl font-bold text-zinc-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{current.location}</h3>
                  <p className="text-zinc-400 text-sm mt-0.5" style={{ fontFamily: "'Raleway', sans-serif" }}>{current.room}</p>
                </div>
                <button onClick={closeLightbox} className="w-8 h-8 flex items-center justify-center text-zinc-400 hover:text-zinc-800 cursor-pointer transition-colors flex-shrink-0 ml-4">
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <p className="text-zinc-600 text-sm leading-relaxed mb-6" style={{ fontFamily: "'Raleway', sans-serif" }}>{current.desc}</p>

              <div className="bg-stone-50 rounded-lg p-4 grid grid-cols-2 gap-4 mb-6">
                {[
                  { label: "Size", value: current.size, icon: "ri-ruler-2-line" },
                  { label: "Frame Colour", value: current.colour, icon: "ri-palette-line" },
                  { label: "Glazing", value: current.glazing, icon: "ri-window-2-line" },
                  { label: "Application", value: current.room, icon: "ri-home-3-line" },
                ].map(d => (
                  <div key={d.label} className="flex items-start gap-2.5">
                    <div className="w-7 h-7 flex items-center justify-center bg-amber-50 rounded-md flex-shrink-0 mt-0.5">
                      <i className={`${d.icon} text-amber-600 text-sm`}></i>
                    </div>
                    <div>
                      <p className="text-zinc-400 text-xs" style={{ fontFamily: "'Raleway', sans-serif" }}>{d.label}</p>
                      <p className="text-zinc-800 text-xs font-semibold mt-0.5" style={{ fontFamily: "'Raleway', sans-serif" }}>{d.value}</p>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href="#quote-form"
                onClick={closeLightbox}
                className="w-full bg-amber-600 hover:bg-amber-500 text-white text-sm font-semibold py-3 rounded-md text-center transition-colors whitespace-nowrap cursor-pointer mt-auto"
                style={{ fontFamily: "'Raleway', sans-serif" }}
              >
                Get a Quote for a Similar Installation
              </a>
            </div>

            {/* Prev / Next arrows */}
            <button
              onClick={prevPhoto}
              className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-black/50 hover:bg-black/70 rounded-full text-white transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button
              onClick={nextPhoto}
              className="absolute right-3 lg:right-auto lg:left-[calc(50%-20px)] lg:top-[calc(50%-140px)] top-1/2 -translate-y-1/2 lg:translate-y-0 w-10 h-10 flex items-center justify-center bg-black/50 hover:bg-black/70 rounded-full text-white transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>

            {/* Counter */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/50 text-white text-xs px-3 py-1 rounded-full lg:hidden" style={{ fontFamily: "'Raleway', sans-serif" }}>
              {(lightboxIndex ?? 0) + 1} / {filtered.length}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
